import { batch } from 'react-redux';

import { getCountryInfo } from '../api/georgeApi';
import * as AssessmentApi from '../api/assessmentApi';
import { receivePrompts } from './promptActions';

export const RECEIVE_COUNTRY_INFO = 'RECEIVE_COUNTRY_INFO';
export const RECEIVE_ASSESSMENT = 'RECEIVE_ASSESSMENT';
export const RECEIVE_APP_TYPE = 'RECEIVE_APP_TYPE';

export const receiveCountryInfo = (countryInfo) => ({
    type: RECEIVE_COUNTRY_INFO,
    countryInfo
});

export const receiveAssessment = (assessment) => ({
    type: RECEIVE_ASSESSMENT,
    assessment
});

export const receiveAppType = (appType) => ({
    type: RECEIVE_APP_TYPE,
    appType
});

export const fetchCountryInfo = () => dispatch => {
    return getCountryInfo()
        .then(value => {
            dispatch(receiveCountryInfo(value));
        });
};

export const fetchAssessment = (assessmentName, versionId) => dispatch => {
    return AssessmentApi.fetchAssessment(assessmentName, versionId)
        .then(res =>
            batch(() => {
                dispatch(receiveAssessment(res.data));
                dispatch(receivePrompts(assessmentName, res.data.prompts));
            }));
}